'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';
import { useAuth } from '@/contexts/AuthContext';

export default function Topbar() {
  const [searchOpen, setSearchOpen] = useState(false);
  const { signOut } = useAuth();
  const router = useRouter();

  const handleSignOut = async () => {
    try {
      await signOut();
      window.location.href = '/landing';
    } catch (error) {
      console.error('Sign out error:', error);
      window.location.href = '/landing';
    }
  };

  return (
    <header className="h-14 border-b border-border bg-card/80 backdrop-blur-sm flex items-center justify-between px-4 lg:px-6 sticky top-0 z-30">
      {/* Left — page context */}
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-positive pulse-dot" />
          <span className="text-xs text-muted-foreground font-mono-data">
            Dernière mise à jour: <span className="text-foreground">16 mai 2026 — 21:33</span>
          </span>
        </div>
      </div>

      {/* Right — actions */}
      <div className="flex items-center gap-1">
        {/* Search */}
        <button
          onClick={() => setSearchOpen(!searchOpen)}
          className="btn-ghost flex items-center gap-2"
          aria-label="Rechercher"
        >
          <Icon name="MagnifyingGlassIcon" size={16} />
          <span className="hidden sm:block text-xs text-muted-foreground">Rechercher</span>
          <kbd className="hidden sm:block text-2xs bg-muted border border-border rounded px-1 py-0.5 text-muted-foreground font-mono-data">⌘K</kbd>
        </button>

        {/* Alerts */}
        <Link href="/profil-utilisateur" className="btn-ghost relative">
          <Icon name="BellIcon" size={16} />
          <span className="absolute top-1 right-1 w-1.5 h-1.5 rounded-full bg-accent" />
        </Link>

        {/* Settings */}
        <Link href="/profil-utilisateur" className="btn-ghost">
          <Icon name="Cog6ToothIcon" size={16} />
        </Link>

        {/* User avatar */}
        <Link href="/profil-utilisateur" className="flex items-center gap-2 ml-2 pl-2 border-l border-border">
          <div className="w-7 h-7 rounded-full bg-primary/20 border border-primary/40 flex items-center justify-center">
            <span className="text-xs font-semibold text-primary font-mono-data">MA</span>
          </div>
          <div className="hidden md:block">
            <p className="text-xs font-medium text-foreground leading-tight">Marc Aubert</p>
            <p className="text-2xs text-primary font-mono-data">Premium</p>
          </div>
        </Link>

        {/* Sign Out */}
        <button
          onClick={handleSignOut}
          className="btn-ghost flex items-center gap-1.5 ml-1 pl-2 border-l border-border text-muted-foreground hover:text-destructive transition-colors"
          aria-label="Se déconnecter"
          title="Se déconnecter"
        >
          <Icon name="ArrowRightOnRectangleIcon" size={16} />
          <span className="hidden sm:block text-xs">Déconnexion</span>
        </button>
      </div>
    </header>
  );
}